const unsuccessfulPassesIds = [3, 21];
const ownFieldPassesIds = [2];
const rivalFieldPassesIds = [20];

/**
 * @author Alejandro
 * @description Calculates and returns the sum of each pass category
 * @param {Array} playList - All plays to be filtered
 * @param {Array<number>} timeSelected - Must be an integer array that contains the selected time sections,
 * if it is null, means that there is not time selection to filter so any play is allowed to be checked
 * @param {number} teamId
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @return {Array<number>} passesData
 */
export function getDonutPassesData(playList, timeSelected, teamId, playValuesIndex) {
  // The passes data order must be [ownField, rivalField, unsuccessful]
  const passesData = [0, 0, 0];
  let categoryId = 0;
  let playTimeSection = 0;
  for (const play of playList) {
    categoryId = play[playValuesIndex.categoryId];
    playTimeSection = play[playValuesIndex.section];
    if (teamId === play[playValuesIndex.teamId] && timeSelected.includes(playTimeSection)) {
      if (ownFieldPassesIds.includes(categoryId)) {
        passesData[0]++;
      }
      if (rivalFieldPassesIds.includes(categoryId)) {
        passesData[1]++;
      }
      if (unsuccessfulPassesIds.includes(categoryId)) {
        passesData[2]++;
      }
    }
  }
  return passesData;
}
